import styled, { css, keyframes } from 'styled-components';
// import { lightenDarkenColor, Button } from '../../../components/common/button';

export const Layout = styled.div`
  display: grid;
  height: 100vh;
  grid-template-areas:
    'snav tbar'
    'snav pnav'
    'snav main';
  grid-template-rows: 50px 50px auto;
  grid-template-columns: 50px auto; /*minmax(200px, 0.4fr) 1fr minmax(200px, 300px);*/
  grid-gap: 5px;
  /*& > div:not(:first-child) {
  border: 1px solid gray;
}
& .blockStatus {
  & h2 {
    font-size: min(2vw, 3em);
  }
}*/
`;

export const PageNavContainer = styled.div`
  grid-area: pnav;
  display: grid;
  height: 10vh;
  margin-left: 5px;
  margin-right: 10px;
  padding: 0px 5px;
  grid-template-areas: 'left right';
  grid-template-columns: auto auto;
  /*& div {
    margin: 10px 5px;
    & button {
      height: 50px;
      width: 100%;
      font-size: 1em;
    }
  }*/
`;

export const PageNavRightContainer = styled.div`
  grid-area: right;
  justify-self: right;
  align-self: center;
  margin-right: 40px;
  grid-template-areas: 'label ddown';
  grid-template-columns: auto auto;
  grid-gap: 10px;
  & select {
    grid-area: ddown;
    background-color: rgb(232, 240, 254) !important;
  }
`;

export const PageNavLeftContainer = styled.div`
  grid-area: left;
  justify-self: left;
  align-self: center;
  padding-left: 5px;
`;

export const MainContainer = styled.div`
  grid-area: main;
  display: flex;
  flex-direction: column;
  margin: 0px 0px 0px;
  padding: 25px 15px 15px;
  overflow-y: scroll;
  grid-row-gap: 2px;
`;
